import { addLocale } from "primereact/api";
import { useState } from "react";
import Dialog from "../../components/Dialog";
import InputLabelTextArea from "../../components/InputLabelTextArea";
import { ptBrDatepickerTranslations } from "../../i18n/locales/pt-br";
import ButtonStyles from "../../styles/components/ButtonStyles";
import DialogStyles from "../../styles/components/DialogStyles";
import {
    StyledInfoLabel,
    StyledInfoText,
} from "../../styles/pages/Schedule/ModalViewDetailsStyles";

addLocale("pt-BR", ptBrDatepickerTranslations);

const { BtnPrimary } = ButtonStyles;
const { StyledModalTitle, StyledContainerButton } = DialogStyles;

interface IModalProps {
    open: boolean;
    onClose?: (callback?: any) => void;
    onSave: (callback?: any) => void;
}

const ModalJustifyPlan: React.FC<IModalProps> = ({ open, onClose, onSave }) => {
    const [justificativa, setJustificativa] = useState("");
    const isLoading = false;
    const [validacoes] = useState<any>(null);
    const [isEmpty, setIsEmpty] = useState("");

    return (
        <Dialog
            openModal={open}
            onHide={onClose}
            size="width-700 modal-white modal-radius-8"
        >
            <StyledModalTitle className="mb-3">
                Enviar para aprovação
            </StyledModalTitle>
            <StyledInfoText>
                Insira abaixo a justificativa para que o TACH seja enviado para
                a aprovação
            </StyledInfoText>
            <div style={{ height: 20 }} />
            <StyledInfoLabel>Justificativa</StyledInfoLabel>
            <InputLabelTextArea
                value={justificativa}
                placeholder="Insira sua justificativa"
                onChange={(event: any) =>
                    setJustificativa(event.target.value as string)
                }
                viewLengthInfo
                maxLength={500}
                style={{
                    height: "107px",
                    borderStyle: "solid",
                    borderColor: "#787878",
                }}
            />
            <StyledInfoText
                style={{
                    color: "red",
                }}
            >
                {validacoes?.code === 400 ? validacoes?.details : ""}
                {isEmpty.length > 0 ? isEmpty : ""}
            </StyledInfoText>
            <StyledContainerButton className="mt-3">
                <BtnPrimary
                    disabled={isLoading}
                    onClick={() => {
                        if (justificativa.length > 0) {
                            onSave(justificativa);
                        } else {
                            setIsEmpty(
                                "Informe uma justificativa, esse campo é obrigatório"
                            );
                        }
                    }}
                >
                    Enviar
                </BtnPrimary>
            </StyledContainerButton>
        </Dialog>
    );
};

export default ModalJustifyPlan;
